import {
  ALLOWED_CONTENT_TYPES,
  MAX_FILE_BYTES,
  type AllowedContentType,
} from './types';

const MB = 1024 * 1024;

const isAllowedContentType = (value: string): value is AllowedContentType =>
  (ALLOWED_CONTENT_TYPES as readonly string[]).includes(value);

/**
 * 클라이언트 선검증. 통과 시 null, 실패 시 한국어 에러 메시지.
 * presign 호출 전 사용자에게 즉시 피드백을 주어 불필요한 왕복을 막는다.
 */
export const validateImageFile = (file: File): string | null => {
  if (!isAllowedContentType(file.type)) {
    return '지원하지 않는 형식입니다. JPEG, PNG, WEBP, GIF 만 업로드할 수 있습니다.';
  }
  if (file.size > MAX_FILE_BYTES) {
    const limitMb = Math.round(MAX_FILE_BYTES / MB);
    return `파일 용량이 너무 큽니다. ${limitMb}MB 이하만 업로드할 수 있습니다.`;
  }
  return null;
};
